import { BaseApi } from "./baseApi";
import { ApiConstants } from "../constants/api";
export class UserApi extends BaseApi {
    constructor() {
        // /user-api — сессионная аутентификация браузера, поэтому withCredentials обязателен
        super("user-api", ApiConstants.BASE_URL + '/user-api');
    }
    async me() {
        const response = await this.getAxios().get('/me');
        return response.data;
    }
    async updateDisplayName(name) {
        const response = await this.getAxios().put('/me/display-name', { displayName: name });
        return response.data;
    }
    async updateSettings(language) {
        const response = await this.getAxios().put('/me/settings', { language });
        return response.data;
    }
    async logout() {
        await this.createClient(ApiConstants.BASE_URL).post('/logout', {});
        // После logout перенаправляем на главную страницу
        window.location.href = "/";
    }
    async listAdminUsers(params) {
        const client = this.createClient(ApiConstants.REST_URL);
        const response = await client.get('/api/v1/admin/users', { params });
        return response.data;
    }
    async adminAction(id, action) {
        await this.createClient(ApiConstants.REST_URL).post(`/api/v1/admin/users/${id}/${action}`, {});
    }
}
